import { NgModule } from '@angular/core';
import {
  AuthWithProviderCommandHandler,
  ChangePasswordCommandHandler,
  IsPasswordAccountQueryHandler,
  LoginCommandHandler,
  LogoutCommandHandler,
  RegisterCommandHandler
} from './index';

@NgModule({
  providers: [
    RegisterCommandHandler,
    LoginCommandHandler,
    LogoutCommandHandler,
    AuthWithProviderCommandHandler,
    ChangePasswordCommandHandler,
    IsPasswordAccountQueryHandler
  ]
})
export class AuthHandlersModule {}
